'use client'

import type { ReactNode } from 'react'
import { useAppLocale } from '@/components/i18n/locale-provider'
import { localizePath } from '@/lib/i18n/routing'
import { useAuthModalLinkClick } from './use-auth-modal'

/**
 * A "Start free" link a server component can render: a real link to
 * `/sign-up` that, once hydrated, opens the auth modal in place on a plain
 * click (`useAuthModalLinkClick`). Like `LocalizedLink`, it takes the path
 * without a locale and links to the reader's (`/de/sign-up`).
 */
export function AuthModalLink({
  href = '/sign-up',
  className,
  children,
}: {
  href?: string
  className?: string
  children: ReactNode
}) {
  const handleClick = useAuthModalLinkClick()
  const locale = useAppLocale()
  const isSitePath = href.startsWith('/') && !href.startsWith('//')
  return (
    <a
      href={isSitePath ? localizePath(locale, href) : href}
      onClick={handleClick}
      className={className}
    >
      {children}
    </a>
  )
}
